import { useQuery } from '@tanstack/react-query'

import { getPhysiologicalDiagnosisById } from '@/services/get-physiological-diagnosis-by-id'

export type UseGetPhysiologicalDiagnosisByIdResponse = ReturnType<
  typeof useGetPhysiologicalDiagnosisById
>['data']

type UseGetPhysiologicalDiagnosesByIdQueryOptions = {
  onError?: () => void
  enabled?: boolean
}

export const GET_DIAGNOSES_QUERY_BY_ID_QUERY = 'GET_DIAGNOSES_QUERY_BY_ID_QUERY'

export const useGetPhysiologicalDiagnosisById = (
  id: string,
  queryOptions?: UseGetPhysiologicalDiagnosesByIdQueryOptions,
) => {
  const query = useQuery(
    [GET_DIAGNOSES_QUERY_BY_ID_QUERY, id],
    ({ signal }) => getPhysiologicalDiagnosisById(id, { signal }),

    {
      ...queryOptions,
    },
  )

  return query
}
